import { render, staticRenderFns } from "./TeacherManagement.vue?vue&type=template&id=d9f7f758"
import script from "./TeacherManagement.vue?vue&type=script&lang=js"
export * from "./TeacherManagement.vue?vue&type=script&lang=js"
import style0 from "./TeacherManagement.vue?vue&type=style&index=0&id=d9f7f758&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports